import { createReducer, on } from "@ngrx/store";
import { BillOfMaterialsLineItem, Contact, EditPlasticsOrderState, MappingProductVersionToQualityAlert, MergeArrayValues, NEW_PLASTICS_ORDER_ID, PlasticsMaterialMixingTask, PlasticsCalendarEvent, PlasticsFinishingStation, PlasticsFinishingTask, PlasticsFixture, InventoryTransaction, PlasticsHardwareItem, PlasticsMaterial, PlasticsOrder, PlasticsOrderedProduct, PlasticsQualityAlert, PlasticsScrapInstance, PlasticsScrapReason, Product, ProductVersion, RotoMachine, RotoManagementState, RotoSchedule, SaveStatus, PlasticsMoldingTask, Tag, VendorHardwareData, ViewPlasticsOrderState, ProductionManagerState, ComplaintLog, ComplaintLogProduct, MappingComplaintLogToQualityAlert, LabelInstance, MappingComplaintLogToContact, PlasticsSkid, PlasticsQualityAlertInspection, ProductInstance, SkidMultiScanState, MappingProductVersionToDockInspectionQuailtyAlert, PlasticsDockInspectionInstance, PlasticsStaticLabel, MappingProductVersionToPlasticsStaticLabel, MappingPlasticsMaterialToQualityAlert } from "@prism/prism-shared";
import { PlasticsActions } from ".";

export interface PlasticsState {
    hardwareItems: PlasticsHardwareItem[];
    inventoryTransactions: InventoryTransaction[];
    vendorHardwareData: VendorHardwareData[];
    products: Product[];
    productVersions: ProductVersion[];
    contacts: Contact[];
    tags: Tag[];
    fixtures: PlasticsFixture[];
    billOfMaterialsLineItems: BillOfMaterialsLineItem[];

    mixingTasks: PlasticsMaterialMixingTask[];
    moldingTasks: PlasticsMoldingTask[];
    finishingTasks: PlasticsFinishingTask[];

    rotoMachines: RotoMachine[];
    scrapReasons: PlasticsScrapReason[];
    plasticsScrapInstances: PlasticsScrapInstance[];
    materials: PlasticsMaterial[];
    plasticsQualityAlerts: PlasticsQualityAlert[];
    plasticsStaticLabel: PlasticsStaticLabel[];
    productDockInspectionQualityAlerts: PlasticsQualityAlert[];
    productDockInspectionInstances: PlasticsDockInspectionInstance[];
    productInstances: ProductInstance[];

    plasticsFinishingStations: PlasticsFinishingStation[];
    plasticsOrders: PlasticsOrder[];
    orderedProducts: PlasticsOrderedProduct[];
    mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
    mappingProductVersionToDockInspectionQualityAlerts: MappingProductVersionToDockInspectionQuailtyAlert[];
    mappingProductVersionToPlasticsStaticLabel: MappingProductVersionToPlasticsStaticLabel[];
    mappingPlasticsMaterialToQualityAlerts: MappingPlasticsMaterialToQualityAlert[];
    calendarEvents: PlasticsCalendarEvent[];
    labelInstances: LabelInstance[];
    qualityAlertInspections: PlasticsQualityAlertInspection[];

    skids: PlasticsSkid[];

    rotoSchedule: RotoSchedule;

    editPlasticsOrderState: EditPlasticsOrderState;
    viewPlasticsOrderState: ViewPlasticsOrderState;
    rotoManagementState: RotoManagementState;
    productionManagerState: ProductionManagerState;
    skidMultiScanState: SkidMultiScanState;
    complaintLogs: ComplaintLog[];
    complaintLogProducts: ComplaintLogProduct[];
    mappingComplaintLogToQualityAlert: MappingComplaintLogToQualityAlert[];
    mappingComplaintLogToContact: MappingComplaintLogToContact[];

    loadingState: number;
    error: any;
}

export const initialState: PlasticsState = {
    hardwareItems: [],
    inventoryTransactions: [],
    vendorHardwareData: [],
    products: [],
    productVersions: [],
    contacts: [],
    tags: [],
    fixtures: [],
    billOfMaterialsLineItems: [],
    rotoMachines: [],
    moldingTasks: [],
    scrapReasons: [],
    plasticsScrapInstances: [],
    materials: [],
    plasticsQualityAlerts: [],
    mappingProductVersionToDockInspectionQualityAlerts: [],
    mappingProductVersionToPlasticsStaticLabel: [],
    mappingPlasticsMaterialToQualityAlerts: [],
    productDockInspectionQualityAlerts: [],
    finishingTasks: [],
    plasticsFinishingStations: [],
    plasticsOrders: [],
    orderedProducts: [],
    mappingProductVersionToQualityAlerts: [],
    calendarEvents: [],
    complaintLogs: [],
    complaintLogProducts: [],
    mappingComplaintLogToQualityAlert: [],
    labelInstances: [],
    skids: [],
    mappingComplaintLogToContact: [],
    qualityAlertInspections: [],
    productInstances: [],
    productDockInspectionInstances: [],
    plasticsStaticLabel: [],
    mixingTasks: [],

    rotoSchedule: null as unknown as RotoSchedule,

    rotoManagementState: {
        rotoSchedule: null as unknown as RotoSchedule,
        moldingTasks: [],
        billOfMaterialsLineItems: [],
        resources: [],
    },

    editPlasticsOrderState: {
        saveStatus: SaveStatus.Saved,
        order: {
            id: NEW_PLASTICS_ORDER_ID,
            orderNumber: '',
            customerId: '',
            customerPurchaseOrderNumber: '',
            createdOn: new Date(),
            createdById: '',
            updatedOn: new Date(),
            updatedById: '',
            files: [],
            shippingAddressId: '',
            shippingContactId: '',
        },
        orderedProducts: [],
        orderedProductIdsToDelete: [],
    },

    viewPlasticsOrderState: {
        order: {
            id: NEW_PLASTICS_ORDER_ID,
            orderNumber: '',
            customerId: '',
            customerPurchaseOrderNumber: '',
            createdOn: new Date(),
            createdById: '',
            updatedOn: new Date(),
            updatedById: '',
            files: [],
            shippingAddressId: '',
            shippingContactId: '',
        },
        orderedProducts: [],
    },

    productionManagerState: {

    },

    skidMultiScanState: {
        skids: [],
        productVersions: [],
        customers: [],
        inspections: [],
    },

    loadingState: 0,
    error: null,
};

export const plasticsReducer = createReducer(
    initialState,
    // =========================================================
    on(PlasticsActions.LoadHardwareItems.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadHardwareItems.success, (state, { hardwareItems }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        hardwareItems,
        error: null
    })),
    on(PlasticsActions.LoadHardwareItems.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadHardwareItemById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemById.success, (state, { hardwareItem }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItem),
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadHardwareItemsByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemsByIds.success, (state, { hardwareItems }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItems),
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemsByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadHardwareItemsByType.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemsByType.success, (state, { hardwareItems }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItems),
        error: null
    })),
    on(PlasticsActions.LoadHardwareItemsByType.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetHardwareItem.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetHardwareItem.success, (state, { hardwareItem }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItem),
        error: null
    })),
    on(PlasticsActions.SetHardwareItem.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadContacts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadContacts.success, (state, { contacts }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        contacts,
        error: null
    })),
    on(PlasticsActions.LoadContacts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadContactById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadContactById.success, (state, { contact }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        contacts: MergeArrayValues(state.contacts, contact),
        error: null
    })),
    on(PlasticsActions.LoadContactById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetContact.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetContact.success, (state, { contact }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        contacts: MergeArrayValues(state.contacts, contact),
        error: null
    })),
    on(PlasticsActions.SetContact.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetVendorHardwareDataAndHardwareItem.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetVendorHardwareDataAndHardwareItem.success, (state, { vendorHardwareData, hardwareItem }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        vendorHardwareData: MergeArrayValues(state.vendorHardwareData, vendorHardwareData),
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItem),
        error: null
    })),
    on(PlasticsActions.SetVendorHardwareDataAndHardwareItem.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetVendorHardwareData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetVendorHardwareData.success, (state, { vendorHardwareData }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        vendorHardwareData: MergeArrayValues(state.vendorHardwareData, vendorHardwareData),
        error: null
    })),
    on(PlasticsActions.SetVendorHardwareData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadVendorHardwareData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareData.success, (state, { vendorHardwareData }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        vendorHardwareData,
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadTags.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadTags.success, (state, { tags }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        tags,
        error: null
    })),
    on(PlasticsActions.LoadTags.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemId.success, (state, { vendorHardwareData }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        vendorHardwareData: MergeArrayValues(state.vendorHardwareData, vendorHardwareData),
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemIds.success, (state, { vendorHardwareData }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        vendorHardwareData,
        error: null
    })),
    on(PlasticsActions.LoadVendorHardwareDataByHardwareItemIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProducts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadProducts.success, (state, { products }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        products,
        error: null
    })),
    on(PlasticsActions.LoadProducts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadReleasedProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadReleasedProductVersions.success, (state, { releasedProductVersions }): PlasticsState => {
        return {
            ...state,
            productVersions: MergeArrayValues(state.productVersions, releasedProductVersions),
            loadingState: state.loadingState - 1,
            error: null
        }
    }),
    on(PlasticsActions.LoadReleasedProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadReleasedAndDraftProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndDraftProductVersions.success, (state, { releasedAndDraftProductVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, releasedAndDraftProductVersions),
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndDraftProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadReleasedAndFinishedProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndFinishedProductVersions.success, (state, { releasedAndFinishedProductVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, releasedAndFinishedProductVersions),
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndFinishedProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadReleasedAndMoldedProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndMoldedProductVersions.success, (state, { releasedAndMoldedProductVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, releasedAndMoldedProductVersions),
        error: null,
    })),
    on(PlasticsActions.LoadReleasedAndMoldedProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),

    on(PlasticsActions.LoadProductById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadProductById.success, (state, { product }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        products: MergeArrayValues(state.products, product),
        error: null
    })),
    on(PlasticsActions.LoadProductById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadBillOfMaterialsLineItemsByProductVersionId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadBillOfMaterialsLineItemsByProductVersionId.success, (state, { lineItems }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        billOfMaterialsLineItems: lineItems,
        error: null,
    })),
    on(PlasticsActions.LoadBillOfMaterialsLineItemsByProductVersionId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadBillOfMaterialsLineItems.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadBillOfMaterialsLineItems.success, (state, { lineItems }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        billOfMaterialsLineItems: lineItems,
        error: null,
    })),
    on(PlasticsActions.LoadBillOfMaterialsLineItems.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductsByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadProductsByIds.success, (state, { products }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        products: MergeArrayValues(state.products, products),
        error: null
    })),
    on(PlasticsActions.LoadProductsByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductVersionById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionById.success, (state, { productVersion }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, productVersion),
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductVersionsByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionsByIds.success, (state, { productVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions,
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionsByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductVersionsByFixtureId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionsByFixtureId.success, (state, { productVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions,
        error: null,
    })),
    on(PlasticsActions.LoadProductVersionsByFixtureId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetProduct.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetProduct.success, (state, { product }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        products: MergeArrayValues(state.products, product),
        error: null
    })),
    on(PlasticsActions.SetProduct.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetProductVersion.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetProductVersion.success, (state, { productVersion }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, productVersion),
        error: null
    })),
    on(PlasticsActions.SetProductVersion.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetBillOfMaterialsLineItems.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetBillOfMaterialsLineItems.success, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetBillOfMaterialsLineItems.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMappingProductVersionToQualityAlerts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMappingProductVersionToQualityAlerts.success, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetMappingProductVersionToQualityAlerts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMappingProductVersionToDockInspectionQuailtyAlert.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMappingProductVersionToDockInspectionQuailtyAlert.success, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetMappingProductVersionToDockInspectionQuailtyAlert.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetProductVersions.success, (state, { productVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, productVersions),
        error: null,
    })),
    on(PlasticsActions.SetProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetProductVersion.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetProductVersion.success, (state, { productVersion }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions: MergeArrayValues(state.productVersions, productVersion),
        error: null
    })),
    on(PlasticsActions.SetProductVersion.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetHardwareInventoryTransaction.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetHardwareInventoryTransaction.success, (state, { transaction }): PlasticsState => {
        let upddatedHardwareItem = { ...state.hardwareItems.find(h => h.id === transaction.entityId) } as PlasticsHardwareItem
        upddatedHardwareItem.qtyOnHand += transaction.change
        return {
            ...state,
            inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transaction),
            hardwareItems: MergeArrayValues(state.hardwareItems, upddatedHardwareItem),
            loadingState: state.loadingState - 1,
            error: null
        }
    }),
    on(PlasticsActions.SetHardwareInventoryTransaction.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetProductInventoryTransaction.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetProductInventoryTransaction.success, (state, { transaction }): PlasticsState => {
        let updatedProduct = { ...state.products.find(h => h.id === transaction.entityId) } as Product
        updatedProduct.qtyOnHand += transaction.change
        return {
            ...state,
            inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transaction),
            products: MergeArrayValues(state.products, updatedProduct),
            loadingState: state.loadingState - 1,
            error: null
        }
    }),
    on(PlasticsActions.SetProductInventoryTransaction.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMaterialInventoryTransaction.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetMaterialInventoryTransaction.success, (state, { transaction }): PlasticsState => {
        let updatedMaterial = { ...state.materials.find(h => h.id === transaction.entityId) } as PlasticsMaterial;
        updatedMaterial.qtyOnHand += transaction.change
        return {
            ...state,
            inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transaction),
            materials: MergeArrayValues(state.materials, updatedMaterial),
            loadingState: state.loadingState - 1,
            error: null
        }
    }),
    on(PlasticsActions.SetMaterialInventoryTransaction.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadRecentHardwareInventoryTransactions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentHardwareInventoryTransactions.success, (state, { transactions }): PlasticsState => ({
        ...state,
        inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transactions),
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentHardwareInventoryTransactions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadRecentProductInventoryTransactions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentProductInventoryTransactions.success, (state, { transactions }): PlasticsState => ({
        ...state,
        inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transactions),
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentProductInventoryTransactions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadRecentMaterialInventoryTransactions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentMaterialInventoryTransactions.success, (state, { transactions }): PlasticsState => ({
        ...state,
        inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transactions),
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.LoadRecentMaterialInventoryTransactions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadRotoSchedule.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadRotoSchedule.success, (state, { rotoSchedule }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            rotoSchedule
        },
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.LoadRotoSchedule.set, (state, { rotoSchedule }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            rotoSchedule
        },
    })),
    on(PlasticsActions.LoadRotoSchedule.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetRotoSchedule.initial, (state, { rotoSchedule }): PlasticsState => ({
        ...state,
        // in initial instead of success so there is no drag/drop flicker
        rotoManagementState: {
            ...state.rotoManagementState,
            rotoSchedule
        },
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetRotoSchedule.success, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetRotoSchedule.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMoldingTasksByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadMoldingTasksByIds.success, (state, { moldingTasks: scheduledProducts }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            moldingTasks: scheduledProducts
        },
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.LoadMoldingTasksByIds.set, (state, { moldingTasks: scheduledProducts }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            moldingTasks: scheduledProducts
        },
    })),
    on(PlasticsActions.LoadMoldingTasksByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMoldingTask.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetMoldingTask.success, (state, { moldingTask: scheduledProduct }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            moldingTasks: MergeArrayValues(state.rotoManagementState.moldingTasks, scheduledProduct)
        },
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetMoldingTask.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMoldingTasks.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetMoldingTasks.success, (state, { tasks }): PlasticsState => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            moldingTasks: MergeArrayValues(state.rotoManagementState.moldingTasks, tasks)
        },
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetMoldingTasks.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetFinishingTasks.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetFinishingTasks.success, (state, { tasks }): PlasticsState => ({
        ...state,
        finishingTasks: MergeArrayValues(state.finishingTasks, tasks),
        loadingState: state.loadingState - 1,
        error: null
    })),
    on(PlasticsActions.SetFinishingTasks.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadFixtures.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadFixtures.success, (state, { fixtures }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        fixtures,
        error: null,
    })),
    on(PlasticsActions.LoadFixtures.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error
    })),
    // =========================================================
    on(PlasticsActions.LoadFixturesByIds.intitial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadFixturesByIds.success, (state, { fixtures }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        fixtures,
        error: null,
    })),
    on(PlasticsActions.LoadFixturesByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetFixture.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetFixture.success, (state, { fixture }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        fixtures: MergeArrayValues(state.fixtures, fixture),
        error: null,
    })),
    on(PlasticsActions.SetFixture.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadFixtureById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadFixtureById.success, (state, { fixture }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        fixtures: MergeArrayValues(state.fixtures, fixture),
        error: null
    })),
    on(PlasticsActions.LoadFixtureById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    on(PlasticsActions.LoadRotoMachines.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadRotoMachines.success, (state, { rotoMachines }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        rotoMachines,
        error: null,
    })),
    on(PlasticsActions.LoadRotoMachines.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error
    })),
    // =========================================================
    on(PlasticsActions.LoadRotoMachineById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadRotoMachineById.success, (state, { rotoMachine }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        rotoMachines: MergeArrayValues(state.rotoMachines, rotoMachine),
        error: null
    })),
    on(PlasticsActions.LoadRotoMachineById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error
    })),
    // =========================================================
    on(PlasticsActions.SetRotoMachine.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetRotoMachine.success, (state, { machine }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        rotoMachines: MergeArrayValues(state.rotoMachines, machine),
        error: null
    })),
    on(PlasticsActions.SetRotoMachine.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error
    })),
    // =========================================================
    on(PlasticsActions.RecordScheduledProductArmCycle.initial, (state) => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.RecordScheduledProductArmCycle.success, (state, { moldingTasks }) => ({
        ...state,
        rotoManagementState: {
            ...state.rotoManagementState,
            moldingTasks: MergeArrayValues(state.rotoManagementState.moldingTasks, moldingTasks)
        },
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.RecordScheduledProductArmCycle.failure, (state, { error }) => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMoldingTaskDependantDataByMoldingTaskIds.initial, (state) => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMoldingTaskDependantDataByMoldingTaskIds.success, (state, {
        moldingTasks,
        products,
        productVersions,
        hardwareItems,
        billOfMaterialsLineItems,
        materials,
        qualityAlerts,
        mappingProductVersionToQualityAlerts,
        mappingPlasticsMaterialToQualityAlerts,
    }) => ({
        ...state,
        products: MergeArrayValues(state.products, products),
        productVersions: MergeArrayValues(state.productVersions, productVersions),
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItems),
        billOfMaterialsLineItems: MergeArrayValues(state.billOfMaterialsLineItems, billOfMaterialsLineItems),
        materials: MergeArrayValues(state.materials, materials),
        plasticsQualityAlerts: MergeArrayValues(state.plasticsQualityAlerts, qualityAlerts),
        mappingProductVersionToQualityAlerts: MergeArrayValues(state.mappingProductVersionToQualityAlerts, mappingProductVersionToQualityAlerts),
        mappingPlasticsMaterialToQualityAlerts,
        rotoManagementState: {
            ...state.rotoManagementState,
            billOfMaterialsLineItems: MergeArrayValues(state.rotoManagementState.billOfMaterialsLineItems, billOfMaterialsLineItems),
            moldingTasks: MergeArrayValues(state.rotoManagementState.moldingTasks, moldingTasks)
        },
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMoldingTaskDependantDataByMoldingTaskIds.failure, (state, { error }) => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductAndProductVersionsByDrawingResourceId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadProductAndProductVersionsByDrawingResourceId.success, (state, { products, productVersions }): PlasticsState => ({
        ...state,
        products: MergeArrayValues(state.products, products),
        productVersions: MergeArrayValues(state.productVersions, productVersions),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadProductAndProductVersionsByDrawingResourceId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadHardwareItemsByDrawingResourceId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadHardwareItemsByDrawingResourceId.success, (state, { hardwareItems }): PlasticsState => ({
        ...state,
        hardwareItems: MergeArrayValues(state.hardwareItems, hardwareItems),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadHardwareItemsByDrawingResourceId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMaterial.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMaterial.success, (state, { material }): PlasticsState => ({
        ...state,
        materials: MergeArrayValues(state.materials, material),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.SetMaterial.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMaterialById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialById.success, (state, { material }): PlasticsState => ({
        ...state,
        materials: MergeArrayValues(state.materials, material),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMaterials.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterials.success, (state, { materials }): PlasticsState => ({
        ...state,
        materials,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterials.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMaterialsByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialsByIds.success, (state, { materials }): PlasticsState => ({
        ...state,
        materials,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialsByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadScrapReasons.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadScrapReasons.success, (state, { scrapReasons }): PlasticsState => ({
        ...state,
        scrapReasons,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadScrapReasons.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.GetPlasticsScrapInstancesByIdFromDate.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.GetPlasticsScrapInstancesByIdFromDate.success, (state, { plasticsScrapInstances }): PlasticsState => ({
        ...state,
        plasticsScrapInstances,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.GetPlasticsScrapInstancesByIdFromDate.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMaterialInventoryTransactionsByMaterialId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialInventoryTransactionsByMaterialId.success, (state, { transactions }): PlasticsState => ({
        ...state,
        inventoryTransactions: MergeArrayValues(state.inventoryTransactions, transactions),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialInventoryTransactionsByMaterialId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMaterialsByIngredientHardwareId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialsByIngredientHardwareId.success, (state, { materials }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        materials,
        error: null,
    })),
    on(PlasticsActions.LoadMaterialsByIngredientHardwareId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMaterialMixingTask.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMaterialMixingTask.success, (state, { task }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mixingTasks: MergeArrayValues(state.mixingTasks, task),
        error: null,
    })),
    on(PlasticsActions.SetMaterialMixingTask.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMaterialMixingTasks.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMaterialMixingTasks.success, (state, { tasks }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mixingTasks: MergeArrayValues(state.mixingTasks, tasks)
    })),
    on(PlasticsActions.SetMaterialMixingTasks.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteMaterialMixingTask.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteMaterialMixingTask.success, (state, { taskId }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mixingTasks: state.mixingTasks.filter(task => task.id !== taskId)
    })),
    on(PlasticsActions.DeleteMaterialMixingTask.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // ===== Purchase Requisitions (read live via valueChanges; reducer only tracks loadingState) =====
    on(PlasticsActions.SetPurchaseRequisition.initial, PlasticsActions.SetPurchaseRequisitions.initial, PlasticsActions.DeletePurchaseRequisition.initial, PlasticsActions.DeletePurchaseRequisitions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetPurchaseRequisition.success, PlasticsActions.SetPurchaseRequisitions.success, PlasticsActions.DeletePurchaseRequisition.success, PlasticsActions.DeletePurchaseRequisitions.success, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.SetPurchaseRequisition.failure, PlasticsActions.SetPurchaseRequisitions.failure, PlasticsActions.DeletePurchaseRequisition.failure, PlasticsActions.DeletePurchaseRequisitions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadPlasticsStaticLabels.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsStaticLabels.success, (state, { plasticsStaticLabels }): PlasticsState => ({
        ...state,
        plasticsStaticLabel: plasticsStaticLabels,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsStaticLabels.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadPlasticsQualityAlerts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsQualityAlerts.success, (state, { plasticsQualityAlerts }): PlasticsState => ({
        ...state,
        plasticsQualityAlerts,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsQualityAlerts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndProductVersions.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndProductVersions.success, (state, {
        mappingProductVersionToQualityAlerts,
        productVersions
    }): PlasticsState => ({
        ...state,
        mappingProductVersionToQualityAlerts,
        productVersions: MergeArrayValues(state.productVersions, productVersions),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndProductVersions.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndQualityAlerts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndQualityAlerts.success, (state, {
        mappingProductVersionToQualityAlerts,
        qualityAlerts
    }): PlasticsState => ({
        ...state,
        mappingProductVersionToQualityAlerts,
        plasticsQualityAlerts: MergeArrayValues(state.plasticsQualityAlerts, qualityAlerts),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadMappingProductVersionToQualityAlertAndQualityAlerts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadPlasticsQualityAlertInspectionChecklistData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsQualityAlertInspectionChecklistData.success, (state, {
        mappingProductVersionToQualityAlerts,
        releasedProductVersions,
        rotoMachines,
        qualityAlerts,
        qualityAlertInspections
    }): PlasticsState => ({
        ...state,
        mappingProductVersionToQualityAlerts,
        productVersions: MergeArrayValues(state.productVersions, releasedProductVersions),
        rotoMachines,
        plasticsQualityAlerts: qualityAlerts,
        qualityAlertInspections,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsQualityAlertInspectionChecklistData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetPlasticsQualityAlertInspection.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetPlasticsQualityAlertInspection.success, (state, { inspection }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        qualityAlertInspections: MergeArrayValues(state.qualityAlertInspections, inspection),
        error: null
    })),
    on(PlasticsActions.SetPlasticsQualityAlertInspection.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadBrowsePlasticsProductsQualityAlertData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadBrowsePlasticsProductsQualityAlertData.success, (state, {
        mappingProductVersionToQualityAlerts,
        releasedProductVersions,
        rotoMachines,
        moldingTasks,
        rotoSchedule,
        qualityAlerts,
    }): PlasticsState => ({
        ...state,
        mappingProductVersionToQualityAlerts,
        productVersions: MergeArrayValues(state.productVersions, releasedProductVersions),
        rotoMachines,
        rotoSchedule,
        moldingTasks,
        plasticsQualityAlerts: qualityAlerts,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadBrowsePlasticsProductsQualityAlertData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadViewPlasticsProductsQualityAlertData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadViewPlasticsProductsQualityAlertData.success, (state, {
        releasedProductVersions,
        qualityAlert,
        complaintLogs,
    }): PlasticsState => ({
        ...state,
        productVersions: releasedProductVersions,
        plasticsQualityAlerts: MergeArrayValues(state.plasticsQualityAlerts, qualityAlert),
        complaintLogs,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadViewPlasticsProductsQualityAlertData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetPlasticsQualityAlert.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetPlasticsQualityAlert.success, (state, { qualityAlert }): PlasticsState => ({
        ...state,
        plasticsQualityAlerts: MergeArrayValues(state.plasticsQualityAlerts, qualityAlert),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.SetPlasticsQualityAlert.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),


    // =========================================================
    on(PlasticsActions.SavePlasticsFinishingTask.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SavePlasticsFinishingTask.success, (state, { task }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        finishingTasks: MergeArrayValues(state.finishingTasks, task),
        error: null,
    })),
    on(PlasticsActions.SavePlasticsFinishingTask.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================

    on(PlasticsActions.LoadActivePlasticsFinishingTasks.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadActivePlasticsFinishingTasks.success, (state, { tasks }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        finishingTasks: tasks,
        error: null,
    })),
    on(PlasticsActions.LoadActivePlasticsFinishingTasks.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadPlasticsFinishingStations.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsFinishingStations.success, (state, { stations }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        plasticsFinishingStations: stations,
        error: null,
    })),
    on(PlasticsActions.LoadPlasticsFinishingStations.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetFinishingStation.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetFinishingStation.success, (state, { station }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        plasticsFinishingStations: MergeArrayValues(state.plasticsFinishingStations, station),
        error: null,
    })),
    on(PlasticsActions.SetFinishingStation.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadOrderAndOrderedProductsById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderAndOrderedProductsById.success, (state, { order, orderedProducts }): PlasticsState => ({
        ...state,
        plasticsOrders: MergeArrayValues(state.plasticsOrders, order),
        orderedProducts: MergeArrayValues(state.orderedProducts, orderedProducts),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderAndOrderedProductsById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadOrderedProductsByCustomerId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderedProductsByCustomerId.success, (state, { orderedProducts }): PlasticsState => ({
        ...state,
        orderedProducts,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderedProductsByCustomerId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadOrderAndOrderedProductByOrderedProductId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderAndOrderedProductByOrderedProductId.success, (state, { order, orderedProduct }): PlasticsState => ({
        ...state,
        plasticsOrders: MergeArrayValues(state.plasticsOrders, order),
        orderedProducts: MergeArrayValues(state.orderedProducts, orderedProduct),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderAndOrderedProductByOrderedProductId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadViewOrderData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadViewOrderData.success, (state, {
        order,
        orderedProducts,
        products,
        releasedProductVersions,
        mixingTasks,
        moldingTasks,
        finishingTasks,
        materials
    }): PlasticsState => ({
        ...state,
        plasticsOrders: MergeArrayValues(state.plasticsOrders, order),
        orderedProducts: MergeArrayValues(state.orderedProducts, orderedProducts),
        products: MergeArrayValues(state.products, products),
        productVersions: MergeArrayValues(state.productVersions, releasedProductVersions),
        mixingTasks,
        moldingTasks,
        finishingTasks,
        materials,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadViewOrderData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadOrdersAndOrderedProductsByProductId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrdersAndOrderedProductsByProductId.success, (state, { orders, orderedProducts }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        plasticsOrders: orders,
        orderedProducts,
        error: null,
    })),
    on(PlasticsActions.LoadOrdersAndOrderedProductsByProductId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetOrder.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetOrder.success, (state, { order }): PlasticsState => ({
        ...state,
        plasticsOrders: MergeArrayValues(state.plasticsOrders, order),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.SetOrder.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteOrder.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteOrder.success, (state, { orderId }): PlasticsState => ({
        ...state,
        plasticsOrders: state.plasticsOrders.filter((order) => order.id !== orderId),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.DeleteOrder.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetOrderedProducts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetOrderedProducts.success, (state, { orderedProducts }): PlasticsState => ({
        ...state,
        orderedProducts: MergeArrayValues(state.orderedProducts, orderedProducts),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.SetOrderedProducts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteOrderedProduct.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteOrderedProduct.success, (state, { orderedProductId }): PlasticsState => ({
        ...state,
        orderedProducts: state.orderedProducts.filter(op => op.id !== orderedProductId),
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.DeleteOrderedProduct.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadBrowseOrdersData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadBrowseOrdersData.success, (state, {
        orders,
        orderedProducts,
        productVersions,
        skids
    }): PlasticsState => ({
        ...state,
        plasticsOrders: orders,
        orderedProducts,
        productVersions,
        skids,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderedProductsByCustomerId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadOrderedProductsByCustomerId.success, (state, { orderedProducts }): PlasticsState => ({
        ...state,
        orderedProducts,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    on(PlasticsActions.LoadBrowseOrdersData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetCalendarEvent.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetCalendarEvent.success, (state, { calendarEvent }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents: MergeArrayValues(state.calendarEvents, calendarEvent),
        error: null
    })),
    on(PlasticsActions.SetCalendarEvent.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetCalendarEvents.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetCalendarEvents.success, (state, { calendarEvents }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents: MergeArrayValues(state.calendarEvents, calendarEvents),
        error: null
    })),
    on(PlasticsActions.SetCalendarEvents.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadCalendarEvents.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadCalendarEvents.success, (state, { calendarEvents }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents,
        error: null
    })),
    on(PlasticsActions.LoadCalendarEvents.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadCalendarEventsBetween.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadCalendarEventsBetween.success, (state, { calendarEvents }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents,
        error: null
    })),
    on(PlasticsActions.LoadCalendarEventsBetween.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteCalendarEventsByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteCalendarEventsByIds.success, (state, { calendarEventIds }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents: state.calendarEvents.filter(e => !calendarEventIds.includes(e.id)),
        error: null
    })),
    on(PlasticsActions.DeleteCalendarEventsByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteCalendarEvent.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteCalendarEvent.success, (state, { calendarEvent }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        calendarEvents: state.calendarEvents.filter((e) => e.id !== calendarEvent.id),
        error: null
    })),
    on(PlasticsActions.DeleteCalendarEvent.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadProductionManagerData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),

    on(PlasticsActions.LoadProductionManagerData.success, (state, {
        orders,
        orderedProducts,
        releasedProductVersions,
        mixingTasks,
        materials,
    }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null,
        plasticsOrders: orders,
        orderedProducts,
        productVersions: releasedProductVersions,
        mixingTasks: mixingTasks,
        materials,
    })),
    on(PlasticsActions.LoadProductionManagerData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error: null,
    })),
    // =========================================================

    on(PlasticsActions.LoadComplaintLogs.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogs.success, (state, { complaintLogs }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs,
        complaintLogProducts: [],
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogs.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================

    on(PlasticsActions.LoadComplaintLogById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogById.success, (state, { complaintLog }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs: MergeArrayValues(state.complaintLogs, complaintLog),
    })),
    on(PlasticsActions.LoadComplaintLogById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetComplaintLog.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetComplaintLog.success, (state, { complaintLog }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs: MergeArrayValues(state.complaintLogs, complaintLog),
        error: null,
    })),
    on(PlasticsActions.SetComplaintLog.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteComplaintLog.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteComplaintLog.success, (state, { complaintLog }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs: state.complaintLogs.filter((c) => c.id !== complaintLog.id),
        error: null,
    })),
    on(PlasticsActions.DeleteComplaintLog.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadViewComplaintLogData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadViewComplaintLogData.success, (state, { complaintLog, complaintLogProducts, productVersions, mappingComplaintLogToQualityAlert, mappingComplaintLogToContact }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs: MergeArrayValues(state.complaintLogs, complaintLog),
        complaintLogProducts,
        productVersions: MergeArrayValues(state.productVersions, productVersions),
        mappingComplaintLogToQualityAlert,
        mappingComplaintLogToContact,
    })),
    on(PlasticsActions.LoadViewComplaintLogData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetComplaintProduct.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetComplaintProduct.success, (state, { complaintLogProduct }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogProducts: MergeArrayValues(state.complaintLogProducts, complaintLogProduct),
        error: null,
    })),
    on(PlasticsActions.SetComplaintProduct.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteComplaintProduct.initial, (state, { complaintLogProduct }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteComplaintProduct.success, (state, { complaintLogProduct }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogProducts: state.complaintLogProducts.filter((c) => c.id !== complaintLogProduct.id),
        error: null,
    })),
    on(PlasticsActions.DeleteComplaintProduct.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadComplaintLogsByProductId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogsByProductId.success, (state, { complaintLogs }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogsByProductId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadComplaintLogsByCustomerId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogsByCustomerId.success, (state, { complaintLogs }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogsByCustomerId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadBrowseComplaintLogData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadBrowseComplaintLogData.success, (state, { complaintLogs, complaintLogProducts, productVersions }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs,
        complaintLogProducts,
        productVersions,
    })),
    on(PlasticsActions.LoadBrowseComplaintLogData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================

    on(PlasticsActions.SetMappingComplaintLogToQualityAlerts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMappingComplaintLogToQualityAlerts.success, (state, { mappingComplaintLogToQualityAlert }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mappingComplaintLogToQualityAlert: MergeArrayValues(state.mappingComplaintLogToQualityAlert, mappingComplaintLogToQualityAlert)
    })),
    on(PlasticsActions.SetMappingComplaintLogToQualityAlerts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadManageMaterialMixingTasksData.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadManageMaterialMixingTasksData.success, (state, {
        productVersions,
        materials,
        orderedProducts,
        materialMixingTasks,
    }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        productVersions,
        materials,
        orderedProducts,
        mixingTasks: materialMixingTasks,
    })),
    on(PlasticsActions.LoadManageMaterialMixingTasksData.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================

    on(PlasticsActions.DeleteMappingComplaintLogToQualityAlerts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteMappingComplaintLogToQualityAlerts.success, (state, { qualityAlertIds }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mappingComplaintLogToQualityAlert: state.mappingComplaintLogToQualityAlert.filter(mapping => !qualityAlertIds.some(id => mapping.qualityAlertId === id))
    })),
    on(PlasticsActions.DeleteMappingComplaintLogToQualityAlerts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),

    // =========================================================
    on(PlasticsActions.SetLabelInstance.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.SetLabelInstance.success, (state, { labelInstance }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        labelInstances: MergeArrayValues(state.labelInstances, labelInstance),
        error: null
    })),
    on(PlasticsActions.SetLabelInstance.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadLabelInstanceById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadLabelInstanceById.success, (state, { labelInstance }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        labelInstances: MergeArrayValues(state.labelInstances, labelInstance),
        error: null
    })),
    on(PlasticsActions.LoadLabelInstanceById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadLabelInstancesByIds.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null
    })),
    on(PlasticsActions.LoadLabelInstancesByIds.success, (state, { labelInstances }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        labelInstances,
        error: null
    })),
    on(PlasticsActions.LoadLabelInstancesByIds.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetMappingComplaintLogToContact.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetMappingComplaintLogToContact.success, (state, { mappings }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mappingComplaintLogToContact: MergeArrayValues(state.mappingComplaintLogToContact, mappings)
    })),
    on(PlasticsActions.SetMappingComplaintLogToContact.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteMappingComplaintLogToContact.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteMappingComplaintLogToContact.success, (state, { mapping }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mappingComplaintLogToContact: state.mappingComplaintLogToContact.filter(m => m.id !== mapping.id),
    })),
    on(PlasticsActions.DeleteMappingComplaintLogToContact.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadComplaintLogsByContactId.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadComplaintLogsByContactId.success, (state, { complaintLogs }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        complaintLogs,
    })),
    on(PlasticsActions.LoadComplaintLogsByContactId.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteMappingsComplaintLogToContacts.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteMappingsComplaintLogToContacts.success, (state, { contactIds }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        mappingComplaintLogToContact: state.mappingComplaintLogToContact.filter(mapping => !contactIds.some(id => mapping.contactId === id))
    })),
    on(PlasticsActions.DeleteMappingsComplaintLogToContacts.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetSkid.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetSkid.success, (state, { skid }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        skids: MergeArrayValues(state.skids, skid),
        error: null,
    })),
    on(PlasticsActions.SetSkid.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SetSkids.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.SetSkids.success, (state, { skids }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        skids: MergeArrayValues(state.skids, skids),
        error: null,
    })),
    on(PlasticsActions.SetSkids.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadSkids.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadSkids.success, (state, { skids }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        skids,
        error: null,
    })),
    on(PlasticsActions.LoadSkids.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.LoadSkidById.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.LoadSkidById.success, (state, { skid }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        skids: MergeArrayValues(state.skids, skid),
        error: null,
    })),
    on(PlasticsActions.LoadSkidById.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.DeleteSkid.initial, (state): PlasticsState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(PlasticsActions.DeleteSkid.success, (state, { skidId }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        skids: state.skids.filter((skid) => skid.id !== skidId),
        error: null,
    })),
    on(PlasticsActions.DeleteSkid.failure, (state, { error }): PlasticsState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    })),
    // =========================================================
    on(PlasticsActions.SkidMultiScanState.addskid, (state, { skid }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            skids: MergeArrayValues(state.skidMultiScanState.skids, skid)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.addskids, (state, { skids }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            skids: MergeArrayValues(state.skidMultiScanState.skids, skids)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.addproductversion, (state, { productVersion }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            productVersions: MergeArrayValues(state.skidMultiScanState.productVersions, productVersion)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.addcustomer, (state, { customer }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            customers: MergeArrayValues(state.skidMultiScanState.customers, customer)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.removeskid, (state, { skidId }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            skids: state.skidMultiScanState.skids.filter((skid) => skid.id !== skidId),
            inspections: state.skidMultiScanState.inspections.filter(i => i.skidId !== skidId)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.addinspections, (state, { inspections }): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            ...state.skidMultiScanState,
            inspections: MergeArrayValues(state.skidMultiScanState.inspections, inspections)
        }
    })),
    on(PlasticsActions.SkidMultiScanState.clear, (state): PlasticsState => ({
        ...state,
        skidMultiScanState: {
            skids: [],
            productVersions: [],
            customers: [],
            inspections: [],
        }
    }))
    // =========================================================

)
